import React from "react";
import BusinessCardContainer from "features/businesscard/containers/BusinessCard";
// src/features/businesscard/containers/BusinessCard.js
function BusinessCard() {
  return <BusinessCardContainer />;
}

export default BusinessCard;
